import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismTable,
  PrismTableHeadersThSublabel,
} from '@mylighthouse/prism-ember';
import HotelStrategyTablesCellsTdNonComputable from 'lumen/components/hotel/strategy/tables/cells/td-non-computable';
import HotelStrategyTablesCellsTdStrategyBaserate from 'lumen/components/hotel/strategy/tables/cells/td-strategy-baserate';
import HotelStrategyTablesCellsTdStrategyHotel from 'lumen/components/hotel/strategy/tables/cells/td-strategy-hotel';
import HotelStrategyTablesCellsThStrategyDetail from 'lumen/components/hotel/strategy/tables/cells/th-strategy-detail';
import {
  COLUMN_CONFIG,
  COLUMN_PROPERTIES,
  COLUMN_WIDTH,
  SUBTYPE_DELIMITER,
  SUBTYPE_VALUES_KEY_STRATEGY,
} from 'lumen/utils/constants/rate-strategy-constants';

interface HotelStrategyTablesTableDetailMembershipSignature {
  Args: {
    onTableSort: unknown;
    sortFunction: unknown;
    sorts: unknown;
    subtypes: unknown;
  };
}

export default class HotelStrategyTablesTableDetailMembership extends Component<HotelStrategyTablesTableDetailMembershipSignature> {
  @service declare intl: Services['intl'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columns() {
    const valuePathHotel = COLUMN_PROPERTIES.HOTELINFO;
    const columns = [
      {
        ...COLUMN_CONFIG.HOTELINFO_HEADER,
        subcolumns: [
          {
            ...COLUMN_CONFIG.HOTELINFO,
            name: this.intl.t('general.hotels'),
            tdComponent: HotelStrategyTablesCellsTdStrategyHotel,
            valuePath: valuePathHotel,
          },
        ],
      },
    ];

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (this.mergedSubtypes.length) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const weekdaySubtype = this.mergedSubtypes[0];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const weekendSubtype = this.mergedSubtypes[1];

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRateWeekday = `${weekdaySubtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathDiscountWeekday = `${weekdaySubtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRateWeekend = `${weekendSubtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathDiscountWeekend = `${weekendSubtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`;

      columns.push({
        thComponent: HotelStrategyTablesCellsThStrategyDetail,
        width: 4 * COLUMN_WIDTH.DEFAULT,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        columnKey: weekdaySubtype.label,
        hasRightBorder: true,
        hasCompareButton: true,
        subtypeHeaderAttributes: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileBookingSubtype: weekdaySubtype.isMobileBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileExpediaSubtype: weekdaySubtype.isMobileExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMealtypeType: weekdaySubtype.isMealtypeType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosBookingSubtype: weekdaySubtype.isPosBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosExpediaSubtype: weekdaySubtype.isPosExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          isBranddotcomMemberRatesSubType:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            weekdaySubtype.isBranddotcomMemberRatesSubType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMemberRatesType: weekdaySubtype.isMemberRatesType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          label: weekdaySubtype.label,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          formattedLabel:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            weekdaySubtype.formattedLabel[SUBTYPE_VALUES_KEY_STRATEGY],
        },
        subcolumns: [
          {
            name: this.intl.t('rates.rate'),
            subLabel: this.intl.t('reports.frequency_weekdays_short'),
            valuePath: valuePathRateWeekday,
            thClassNames: 'truncate text-200--bold',
            thComponent: PrismTableHeadersThSublabel,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: weekdaySubtype.label,
          },
          {
            name: this.intl.t('strategy.metric_block.discount'),
            subLabel: this.intl.t('reports.frequency_weekdays_short'),
            valuePath: valuePathDiscountWeekday,
            thClassNames: 'truncate text-200--bold',
            thComponent: PrismTableHeadersThSublabel,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdNonComputable,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: weekdaySubtype.label,
          },
          {
            name: this.intl.t('rates.rate'),
            subLabel: this.intl.t('reports.frequency_weekends_short'),
            valuePath: valuePathRateWeekend,
            thClassNames: 'truncate text-200--bold',
            thComponent: PrismTableHeadersThSublabel,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: weekendSubtype.label,
          },
          {
            name: this.intl.t('strategy.metric_block.discount'),
            subLabel: this.intl.t('reports.frequency_weekends_short'),
            valuePath: valuePathDiscountWeekend,
            thClassNames: 'truncate text-200--bold',
            thComponent: PrismTableHeadersThSublabel,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdNonComputable,
            width: COLUMN_WIDTH.DEFAULT,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: weekendSubtype.label,
            textAlign: 'center',
            hasRightBorder: true,
          },
        ],
      });
    }

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.individualSubtypes.forEach((subtype) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathRate = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const valuePathDiscount = `${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`;

      columns.push({
        thComponent: HotelStrategyTablesCellsThStrategyDetail,
        width: 2 * COLUMN_WIDTH.DEFAULT,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        columnKey: subtype.label,
        textAlign: 'center',
        hasRightBorder: true,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        hasCompareButton: subtype.isBranddotcomMemberRatesSubType,
        subtypeHeaderAttributes: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileBookingSubtype: subtype.isMobileBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMobileExpediaSubtype: subtype.isMobileExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMealtypeType: subtype.isMealtypeType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosBookingSubtype: subtype.isPosBookingSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isPosExpediaSubtype: subtype.isPosExpediaSubtype,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          isBranddotcomMemberRatesSubType:
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            subtype.isBranddotcomMemberRatesSubType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          isMemberRatesType: subtype.isMemberRatesType,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          label: subtype.label,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          formattedLabel: subtype.formattedLabel[SUBTYPE_VALUES_KEY_STRATEGY],
        },
        subcolumns: [
          {
            name: this.intl.t('rates.rate'),
            valuePath: valuePathRate,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdStrategyBaserate,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
            columnKey: subtype.label,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            isRedirectDisabled: !subtype.isBranddotcomMemberRatesSubType, // Only redirect from brand.com member rates
          },
          {
            name: this.intl.t('strategy.metric_block.discount'),
            valuePath: valuePathDiscount,
            // @ts-expect-error: Incorrect type
            tdComponent: HotelStrategyTablesCellsTdNonComputable,
            width: COLUMN_WIDTH.DEFAULT,
            textAlign: 'center',
            hasRightBorder: true,
          },
        ],
      });
    });

    return columns;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasMergedSubtypes() {
    // Merge the first and second (sorted) subtype if they are both branddotcom member rates
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.args.subtypes[0].isBranddotcomMemberRatesSubType &&
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      this.args.subtypes[1].isBranddotcomMemberRatesSubType
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get individualSubtypes() {
    // Skip branddotcom member rates for weekdays and weekends if we have them both (already in mergedSubtypes)
    if (this.hasMergedSubtypes) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return this.args.subtypes.slice(2);
    }
    return this.args.subtypes;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get mergedSubtypes() {
    // Group branddotcom member rates for weekdays and weekends if we have them both
    if (this.hasMergedSubtypes) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
      return this.args.subtypes.slice(0, 2);
    }
    return [];
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rows() {
    // @ts-expect-error: Incorrect type
    const rows = [];

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const membershipData = [...this.args.membershipDataPerHotelInfo.values()];

    membershipData.forEach((rowData) => {
      const row = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        [COLUMN_PROPERTIES.HOTELINFO]: rowData[COLUMN_PROPERTIES.HOTELINFO],
      };

      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.subtypes.forEach((subtype) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.RATE}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.RATE];
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        row[`${subtype.id}${SUBTYPE_DELIMITER}${COLUMN_PROPERTIES.DISCOUNT}`] =
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          rowData[subtype.id][COLUMN_PROPERTIES.DISCOUNT];
      });

      rows.push(row);
    });

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return rows;
  }

  <template>
    <PrismTable
      {{! @glint-expect-error: Incorrect type }}
      @columns={{this.columns}}
      @enableAutoSortsUpdate={{true}}
      @fillMode="first-column"
      {{! @glint-expect-error: Incorrect type }}
      @initialSorts={{@sorts}}
      {{! @glint-expect-error: Incorrect type }}
      @onTableSort={{@onTableSort}}
      @removeTableBorder={{true}}
      @rows={{this.rows}}
      {{! @glint-expect-error: Incorrect type }}
      @sortFunction={{@sortFunction}}
      @widthConstraint="eq-container-slack"
    />
  </template>
}
